import {CloudIcon} from '@primer/octicons-react'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {TrailingVisualSlotProps} from '../agent-profile-types'
import styles from '../../components/AgentTypeTrailingVisual.module.css'

/**
 * Default trailing visual for cloud-based agents.
 * Renders a CloudIcon, FF-gated behind copilot_mission_control_session_filters.
 */
export function DefaultTrailingVisual(_props: TrailingVisualSlotProps) {
  if (!isFeatureEnabled('copilot_mission_control_session_filters')) {
    return null
  }

  return (
    <span
      className={styles.wrapper}
      role="img"
      aria-label="Cloud session"
      data-testid="agent-type-trailing-visual-cloud"
    >
      <CloudIcon />
    </span>
  )
}
